import { Button, Modal, Select } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { serverUrl } from "../../../../../nestserver";
import DatePicker from "../../../../../components/inputs/MomentDatePicker";
import MontessoriAttendanceTable from "./MontessoriAttendanceTable";
import AttendanceViewHistory from "./AttendanceViewHistory";

const MontessoriAttendanceHome = () => {
  const { Option } = Select;
  const [ViewHistoryPopup, setViewHistoryPopup] = useState(false);
  const [classId, setClassId] = useState();
  const [selectedDate, setSelectedDate] = useState(moment());
  const selectedDateStr = selectedDate.format("YYYY-MM-DD");

  const handleSelectChange = (id) => {
    setClassId(id);
  };

  // Fetch instructor's classes
  async function fetchInstructorClasses() {
    const res = await axios({
      method: "get",
      url: serverUrl + "/teachers/instructor-classes",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  }
  const classes = useQuery(
    "/teachers/instructor-classes",
    fetchInstructorClasses,
  );

  // Fetch Montessori attendance for selected class and date
  const fetchMontessoriAttendance = async () => {
    if (!classId || !selectedDateStr) return null;

    const res = await axios.get(
      `${serverUrl}/montessori/attendance/class/${classId}?date=${selectedDateStr}`,
      {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        },
      },
    );
    return res.data;
  };

  const attendanceData = useQuery(
    ["montessori-attendance", classId, selectedDateStr],
    fetchMontessoriAttendance,
    {
      enabled: !!classId && !!selectedDateStr,
    },
  );

  return (
    <div className="attendance">
      <div className="pt-8">
        <div className="bg-white p-10 rounded-2xl">
          <div className="text-2xl text-orange-500 font-semibold pb-8">
            Montessori Attendance
          </div>
          <div className="flex gap-10px mb-4">
            <h6 className="font-semibold text-base">Class: &nbsp;</h6>
            <Select
              showSearch
              showArrow
              placeholder="Select Class"
              className="w-1/2 bg-gray-300"
              style={{
                border: "6px",
                backgroundColor: "#EBEBEB",
                width: "33%",
              }}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => handleSelectChange(value)}
            >
              {classes.isSuccess &&
                classes?.data?.map((data) => {
                  return (
                    <Option key={data._id} value={data._id}>
                      {data.name}
                    </Option>
                  );
                })}
            </Select>
          </div>
          <div className="flex justify-between items-center">
            <h6 className="text-base font-semibold flex items-center">
              Date: &nbsp;
              <DatePicker
                value={selectedDate}
                format="DD MMM YYYY"
                allowClear={false}
                disabledDate={(d) => !d || d.isAfter(moment().endOf("day"))}
                onChange={(date) => date && setSelectedDate(date)}
                getPopupContainer={(trigger) => trigger.parentNode}
              />
            </h6>
            <div className="flex justify-end items-center pt-4 gap-4">
              <Button size="large" onClick={() => setViewHistoryPopup(true)}>
                View History
              </Button>
            </div>
          </div>
          <div>
            <MontessoriAttendanceTable
              attendanceData={attendanceData}
              classId={classId}
              selectedDate={selectedDateStr}
            />
          </div>

          {/* View History Modal */}
          <Modal
            width={900}
            visible={ViewHistoryPopup}
            onOk={() => setViewHistoryPopup(false)}
            onCancel={() => {
              setViewHistoryPopup(false);
            }}
            footer={null}
          >
            <AttendanceViewHistory classId={classId} />
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default MontessoriAttendanceHome;
